import App from './app/app';
import ReactDOM from 'react-dom';
import React from 'react';
import { IAppData } from './app/app';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('membership-activate-account-app');
    if (!$root) return;

    const $json = document.getElementById('activate-account-json-data');
    if(!$json) return;

    let json = null;

    try{
        const content = $json.textContent;
        json = content == null ? null : JSON.parse(content) as IAppData;
    }
    catch(ex){}

    ReactDOM.render(
        <React.StrictMode>
            <App data={ json } />
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {};